import React from 'react'

import Bus from './bus'
// import AccountManager from './managers/account'

import {
  logger
} from './utils'

import {
  ApplicationDataProvider,
  createApplicationState,
  createSettings,
  SettingsProvider
} from './state'

// import Notifications from '@apollo/global/Notifications'

/*
  Main Apollo application component
 */
export default function Apollo (props) {
  /*
    Creating application state with hook
    Contains [state, dispatch]
    providing an opportunity for binding
    dynamic data and dispatch function
  */
  const [
    ApolloApplicationState,
    ApolloApplicationDispatch
  ] = createApplicationState()

  const settingsContext = createSettings()

  React.useEffect(() => {
    logger.debug('[app]', '🔥', 'mounted')

    // Subscribing root dispatcher to Bus
    Bus.subscribeDispatcher(ApolloApplicationDispatch)

    // Because we need to wait for Cordova to boot, we need to move this request into Akira
    // AccountManager.resolveAuthentication()
    //  .catch(error => {
    //    // Logging auth resolve error
    //    logger.debug('[app]', error.message)
    //  })
  }, [])

  return (
    <ApplicationDataProvider value={ApolloApplicationState}>
      <SettingsProvider value={settingsContext}>
        {props.children}
      </SettingsProvider>
    </ApplicationDataProvider>
  )
}
